// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__WvMzg","footer":"ModalCreateQualiphyProcedure_footer__2W-Pt","additionData":"ModalCreateQualiphyProcedure_additionData__1crf4"};